export enum NotebookResourceType {
    Notebook = 1,
    Page = 2,
}
